import { FC, Fragment } from "react";
import React from "react";
import { FormControl, RadioGroup, makeStyles, createStyles, Grid } from "@material-ui/core";
import { ChangeNames } from "../../clients/FirebaseClient/types";
import { useFormModel } from "../core/FormModelHelpes";
import { useStyles } from "../../useStyles";
import { FormControlLabel } from "../core/FormControlLabel";
import { Radio } from "../core/Radio";

const useFormControlStyles = makeStyles(() =>
    createStyles({
        container: {
            display: "flex",
            flexDirection: "row",
        },
        firstFormControlLabelStyle: {
            marginRight: 64,
        },
    }),
);

export const NewConnectionMultilineCellarOuterWallBushingForm: FC = () => {
    const { values, setValues, submitChange } = useFormModel<
        ChangeNames.NEW_CONNECTION_MULTILINE_CELLAR_OUTER_WALL_BUSHING
    >();

    const convertValue = (): string => {
        if (values.newConnectionMultilineCellarOuterWallBushing.value === null) return "";
        if (values.newConnectionMultilineCellarOuterWallBushing.value.coreDrilling)
            return "coreDrilling";
        if (values.newConnectionMultilineCellarOuterWallBushing.value.casingPipe)
            return "casingPipe";
        return "";
    };

    const classes = useStyles();
    const formControlStyles = useFormControlStyles();
    const selection = convertValue();

    return (
        <Fragment>
            <div className={classes.container}>
                <h4 className={classes.h4} style={{ marginBottom: 0, marginTop: 40 }}>
                    Wie soll die Wanddurchführung erfolgen?
                </h4>
                <FormControl component="fieldset" style={{ display: "flex" }}>
                    <RadioGroup
                        value={selection}
                        onChange={(e, v) => {
                            const newValues = setValues(values => {
                                values.newConnectionMultilineCellarOuterWallBushing.value = {
                                    coreDrilling: v.indexOf("coreDrilling") >= 0,
                                    casingPipe: v.indexOf("casingPipe") >= 0,
                                };
                            });
                            submitChange(newValues);
                        }}
                    >
                        <Grid container spacing={7} className={formControlStyles.container}>
                            <Grid item xs={9} sm={12} md={12}>
                                <FormControlLabel
                                    className={formControlStyles.firstFormControlLabelStyle}
                                    value="coreDrilling"
                                    control={<Radio />}
                                    label="Kernbohrung"
                                    error={
                                        values.newConnectionMultilineCellarOuterWallBushing
                                            .error !== null
                                    }
                                />
                                <FormControlLabel
                                    value="casingPipe"
                                    control={<Radio />}
                                    label="Futterrohr"
                                    error={
                                        values.newConnectionMultilineCellarOuterWallBushing
                                            .error !== null
                                    }
                                />
                            </Grid>
                        </Grid>
                    </RadioGroup>
                </FormControl>
            </div>
        </Fragment>
    );
};
